<app-modal-template [title]="data.title" [size]="PencilModalSizeEnum.SMALL">
  <div content-description class="create-folder-dialog__body">
    <label for="folder-name-input" class="create-folder-dialog__label">
      {{ 'FOLDER NAME' | translate }}
    </label>
    <input
      id="folder-name-input"
      class="create-folder-dialog__input"
      type="text"
      cdkFocusInitial
      [(ngModel)]="folderName"
      (ngModelChange)="checkFolderName()"
      (keyup.enter)="createFolder()"
      [class.create-folder-dialog__input--invalid]="folderExists"
      [attr.aria-invalid]="folderExists"
      aria-describedby="folder-name-feedback"
      name="folder"
      required
    />
    <div
      *ngIf="folderExists"
      id="folder-name-feedback"
      class="create-folder-dialog__error"
      role="alert"
    >
      {{ 'A folder with this name already exists in this directory.' | translate }}
    </div>
  </div>
  <div content-actions>
    <app-pencil-button
      [theme]="PencilButtonThemeEnum.SECONDARY"
      icon="close"
      [iconConfig]="{ type: IconTypes.matIcon }"
      [label]="'Cancel' | translate"
      (clickEvent)="closeDialog()"
    >
    </app-pencil-button>
    <app-pencil-button
      [theme]="PencilButtonThemeEnum.PRIMARY"
      icon="check"
      [iconConfig]="{ type: IconTypes.matIcon }"
      [label]="'Create' | translate"
      [disabled]="isCreateDisabled"
      (clickEvent)="createFolder()"
    >
    </app-pencil-button>
  </div>
</app-modal-template>
